import React from 'react';
import PropTypes from 'prop-types';

import formikPropTypes from '@zr/components/Fields/Formik/formikPropTypes';

import {
  getLegendText,
} from '@zr/jobseeker-public/apps/profile-form/utilities/educationFormUtilities';

import MinimalEducationFields from './MinimalEducationFields';

export function MinimalEducationFieldset({
  disabled, formikProps, numAdded, enableRichText,
}) {
  return (
    <fieldset disabled={disabled}>
      <legend className="title">{getLegendText(numAdded)}</legend>
      <MinimalEducationFields formikProps={formikProps} enableRichText={enableRichText} />
    </fieldset>
  );
}

MinimalEducationFieldset.propTypes = {
  disabled: PropTypes.bool,
  formikProps: formikPropTypes.isRequired,
  numAdded: PropTypes.number,
  enableRichText: PropTypes.bool,
};

MinimalEducationFieldset.defaultProps = {
  disabled: false,
  numAdded: 0,
  enableRichText: false,
};

export default MinimalEducationFieldset;
